import React, { useEffect, useState, useRef } from "react";
import { listarVehiculos, listarMaquinaria } from "../api";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../styles.css";
import logo from "../assets/logo.png";

moment.locale("es");
moment.updateLocale("es", { week: { dow: 1 } });
const localizer = momentLocalizer(moment);

const CalendarioITV = ({ onCerrar }) => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fechaVisible, setFechaVisible] = useState(new Date());
  const calendarioRef = useRef();

  useEffect(() => {
    const logoEl = document.querySelector('.header-logo');
    if (logoEl) {
        logoEl.style.opacity = '0';
        logoEl.style.pointerEvents = 'none';
    }

    return () => {
      if (logoEl) {
          logoEl.style.opacity = '1';
          logoEl.style.pointerEvents = 'auto';
      }
    };
  }, []);

  useEffect(() => {
    const cargarEventos = async () => {
      try {
        const [vehiculos, maquinaria] = await Promise.all([
          listarVehiculos(),
          listarMaquinaria(),
        ]);

        const parseFecha = (fechaStr) => {
          if (!fechaStr) return null;
          const fecha = new Date(fechaStr);
          return isNaN(fecha.getTime()) ? null : fecha;
        };

        const crearEventos = (lista, tipo) =>
          lista
            .map((item) => {
              const fecha = parseFecha(item.fecha_proxima_itv);
              if (!fecha) return null;
              return {
                id: `${tipo}-${item.id}`,
                title: `${item.matricula || ""}${
                  item.matricula && item.nombre ? " - " : ""
                }${item.nombre || ""}`,
                start: fecha,
                end: fecha,
                allDay: true,
                resource: item,
              };
            })
            .filter(Boolean);

        const eventosVehiculos = crearEventos(vehiculos, "vehiculo");
        const eventosMaquinaria = crearEventos(maquinaria, "maquinaria");

        setEventos([...eventosVehiculos, ...eventosMaquinaria]);
      } catch (err) {
        console.error("Error cargando ITV:", err);
      } finally {
        setLoading(false);
      }
    };

    cargarEventos();
  }, []);

  if (loading) return <p>Cargando calendario de ITV...</p>;

  const eventStyleGetter = () => ({
    style: {
      backgroundColor: "#0093f5ff",
      color: "white",
      borderRadius: "6px",
      border: "none",
      padding: "4px 8px",
      fontSize: "13px",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    },
  });

  const exportarPDF = async () => {
    const input = calendarioRef.current;
    if (!input) return;

    const toolbar = input.querySelector(".rbc-toolbar");
    if (toolbar) toolbar.style.display = "none";

    const mesActual = moment(fechaVisible).format("MMMM YYYY");
    const titulo = `Calendario ITV — ${
      mesActual.charAt(0).toUpperCase() + mesActual.slice(1)
    }`;

    const canvas = await html2canvas(input, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      scrollY: -window.scrollY,
    });

    if (toolbar) toolbar.style.display = "flex";

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const availableHeight = pageHeight - 30;
    const imgWidth = pageWidth - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const yOffset = (availableHeight - imgHeight) / 2 + 20;
    const finalY = yOffset < 30 ? 30 : yOffset;

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(18);
    const textWidth = pdf.getTextWidth(titulo);
    pdf.text(titulo, (pageWidth - textWidth) / 2, 20);

    try {
      const logoImg = new Image();
      logoImg.src = logo;
      await new Promise((resolve) => {
        logoImg.onload = () => resolve();
      });

      const maxLogoWidth = 50;
      const logoAspect = logoImg.width / logoImg.height;
      const logoWidth = maxLogoWidth;
      const logoHeight = logoWidth / logoAspect;

      pdf.addImage(
        logoImg,
        "PNG",
        pageWidth - logoWidth - 10,
        8,
        logoWidth,
        logoHeight
      );
    } catch (err) {
      console.warn("⚠️ No se pudo agregar el logo:", err);
    }

    pdf.addImage(imgData, "PNG", margin, finalY, imgWidth, imgHeight);
    pdf.save(`Calendario_ITV_${moment(fechaVisible).format("MMMM_YYYY")}.pdf`);
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "15px",
        }}
      >
        <h2 style={{ fontSize: "29px", fontWeight: "bold", color: "#000", margin: 0 }}>
          Calendario ITV
        </h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            alignItems: "flex-end",
          }}
        >
          <button
            onClick={onCerrar}
            className="botonAccion botonAzul"
            style={{ padding: "6px 14px", fontSize: 14 }}
          >
            Cerrar
          </button>
          <button
            onClick={exportarPDF}
            className="botonAccion botonAzul"
            style={{ padding: "6px 14px", fontSize: 14 }}
          >
            Exportar PDF
          </button>
        </div>
      </div>

      <div ref={calendarioRef} style={{ height: "80vh" }}>
        <Calendar
          localizer={localizer}
          culture="es"
          events={eventos}
          startAccessor="start"
          endAccessor="end"
          views={["month", "agenda"]}
          eventPropGetter={eventStyleGetter}
          onNavigate={(fecha) => setFechaVisible(fecha)}
          messages={{
            month: "Mes",
            week: "Semana",
            day: "Día",
            agenda: "Agenda",
            today: "Hoy",
            previous: "Anterior",
            next: "Siguiente",
            showMore: (total) => `+ Ver ${total} más`,
            noEventsInRange: "No hay ITV en este rango de fechas",
          }}
        />
      </div>
    </div>
  );
};

export default CalendarioITV;
